import {UntypedFormControl, Validators} from '@angular/forms';
import {RangeValidator} from '../../../create/properties/validator/range-validator';
import {ValidatorRegex} from '../../../create/properties/validator/validator-enum';

interface UpdateLocationFormInterface {
  type: UntypedFormControl;
  name: UntypedFormControl;
  description: UntypedFormControl;
  x: UntypedFormControl;
  y: UntypedFormControl;
  z: UntypedFormControl;
  endDate: UntypedFormControl;
  distance: UntypedFormControl;
  directionFrom: UntypedFormControl;
  directionTo: UntypedFormControl;
  napToALatConversion: UntypedFormControl;
}

export const TidalStreamUpdateLocationForm: UpdateLocationFormInterface = {
  type: new UntypedFormControl({disabled: true}, Validators.required),
  name: new UntypedFormControl({disabled: true}, [Validators.required, Validators.maxLength(40)]),
  description: new UntypedFormControl({disabled: true}, [Validators.required, Validators.maxLength(254)]),
  x: new UntypedFormControl(null, [
    Validators.required,
    Validators.pattern(ValidatorRegex.Decimal),
  ]),
  y: new UntypedFormControl(null, [
    Validators.required,
    Validators.pattern(ValidatorRegex.Decimal),
  ]),
  z: new UntypedFormControl(null, [
    Validators.pattern(ValidatorRegex.Decimal),
  ]),
  endDate: new UntypedFormControl(null, [
  ]),
  distance: new UntypedFormControl(null, [
    Validators.required,
    Validators.pattern(ValidatorRegex.PositiveInteger),
  ]),
  directionFrom: new UntypedFormControl(null, [
    Validators.required,
    Validators.pattern(ValidatorRegex.PositiveInteger),
    RangeValidator.validate(0, 359),
  ]),
  directionTo: new UntypedFormControl(null, [
    Validators.required,
    Validators.pattern(ValidatorRegex.PositiveInteger),
    RangeValidator.validate(0, 359),
  ]),
  napToALatConversion: new UntypedFormControl(null, [
    Validators.pattern(ValidatorRegex.Decimal),
  ]),
};

export const HeightOfTideUpdateLocationForm: UpdateLocationFormInterface = {
  type: new UntypedFormControl({disabled: true}, Validators.required),
  name: new UntypedFormControl({disabled: true}, [Validators.required, Validators.maxLength(40)]),
  description: new UntypedFormControl({disabled: true}, [Validators.required, Validators.maxLength(254)]),
  x: new UntypedFormControl(null, [
    Validators.required,
    Validators.pattern(ValidatorRegex.Decimal),
  ]),
  y: new UntypedFormControl(null, [
    Validators.required,
    Validators.pattern(ValidatorRegex.Decimal),
  ]),
  z: new UntypedFormControl(null, [
    Validators.pattern(ValidatorRegex.Decimal),
  ]),
  endDate: new UntypedFormControl(null, [
  ]),
  distance: new UntypedFormControl(null, [
    Validators.pattern(ValidatorRegex.PositiveInteger),
  ]),
  directionFrom: new UntypedFormControl(null, [
    Validators.pattern(ValidatorRegex.PositiveInteger),
    RangeValidator.validate(0, 359),
  ]),
  directionTo: new UntypedFormControl(null, [
    Validators.pattern(ValidatorRegex.PositiveInteger),
    RangeValidator.validate(0, 359),
  ]),
  napToALatConversion: new UntypedFormControl(null, [
    Validators.required,
    Validators.pattern(ValidatorRegex.Decimal),
  ]),
};

export const GeneralUpdateLocationForm: UpdateLocationFormInterface = {
  type: new UntypedFormControl({disabled: true}, Validators.required),
  name: new UntypedFormControl({disabled: true}, [Validators.required, Validators.maxLength(40)]),
  description: new UntypedFormControl({disabled: true}, [Validators.required, Validators.maxLength(254)]),
  x: new UntypedFormControl(null, [
    Validators.required,
    Validators.pattern(ValidatorRegex.Decimal),
  ]),
  y: new UntypedFormControl(null, [
    Validators.required,
    Validators.pattern(ValidatorRegex.Decimal),
  ]),
  z: new UntypedFormControl(null, [
    Validators.pattern(ValidatorRegex.Decimal),
  ]),
  endDate: new UntypedFormControl(null, [
  ]),
  distance: new UntypedFormControl(null, [
    Validators.pattern(ValidatorRegex.PositiveInteger),
  ]),
  directionFrom: new UntypedFormControl(null, [
    Validators.pattern(ValidatorRegex.PositiveInteger),
    RangeValidator.validate(0, 359),
  ]),
  directionTo: new UntypedFormControl(null, [
    Validators.pattern(ValidatorRegex.PositiveInteger),
    RangeValidator.validate(0, 359),
  ]),
  napToALatConversion: new UntypedFormControl(null, [
    Validators.pattern(ValidatorRegex.Decimal),
  ]),
};
